import React, { useState, useContext, useEffect } from 'react';
import BannerForm from "../bannerData/DialogEditBanner"
import { AuthContext } from "../../../common/Auth"
import { USERTYPES } from "../../../constant/userType"

export default function EditBannerIcon ({ bannerId, fromEditAction }) {

    const { userType } = useContext(AuthContext)
    const [open, setOpen] = useState(false);
    const [toolTip, setToolTip] = useState('');
    const handleClose = () => {
        setOpen(!open)
    }
    const handleOpen = (e) => {
        e.preventDefault();
        setOpen(!open)
    }
    useEffect(() => {
        if (fromEditAction && fromEditAction == 'bgImg') {
            setToolTip('Update Banner Image')
        } else if (fromEditAction && fromEditAction == 'primaryText') {
            setToolTip('Update Primary Text')
        } else if (fromEditAction && fromEditAction == 'secondaryText') {
            setToolTip('Update Secondary Text')
        } else if (fromEditAction && fromEditAction == 'innerImg') {
            setToolTip('Update Inner Image')
        } else if (fromEditAction && fromEditAction == 'buttonDesign') {
            setToolTip('Update Button Text')
        } else if (fromEditAction && fromEditAction == 'shapeTitle') {
            setToolTip('Update Text')
        } else if (fromEditAction && fromEditAction == 'text') {
            setToolTip('Update Description Text')
        } else if (fromEditAction && fromEditAction == 'bgColor') {
            setToolTip('Update Text Alignment and Background Color')
        }

    }, [fromEditAction])
    return (
        <>
            {userType && userType !== USERTYPES.USER && (
                <>
                    <h6 className="animated" onClick={(e) => { handleOpen(e) }}>
                        <i className="fa fa-edit" title={toolTip}></i>
                    </h6>
                    <BannerForm open={open} handleClose={handleClose} bannerId={bannerId} fromEditAction={fromEditAction} />
                </>
            )}
        </>
    );
}